namespace TabAurous.OMS {
    export interface LabourMasterRow {
        LabourId?: number;
        AttributeId?: number;
        ItemTypeId?: number;
        ItemType?: string;
        ProductTypeId?: number;
        ProductTypeName?: string;
        Attribute?: string;
        CategoryId?: number;
        CategoryName?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        StoneColorId?: number;
        ShapeId?: number;
        SieveId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        FromWt?: number;
        ToWt?: number;
        FromParts?: number;
        ToParts?: number;
        SettingId?: number;
        ProcessId?: number;
        ProcessName?: string;
        CalcOnId?: number;
        LossPer?: number;
        PurStdLabour?: number;
        SaleStdLabour?: number;
        MinLabour?: number;
        MaxLabour?: number;
        MaxOrMin?: number;
        FixedName?: string;
        RateType?: string;
        SuperTypeName?: string;
        BrandName?: string;
        CollectionName?: string;
        ProcessTypeId?: number;
        IsCustomerItem?: boolean;
        CalculateTo?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace LabourMasterRow {
        export const idProperty = 'LabourId';
        export const nameProperty = 'String1';
        export const localTextPrefix = 'OMS.LabourMaster';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            LabourId = "LabourId",
            AttributeId = "AttributeId",
            ItemTypeId = "ItemTypeId",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            ProductTypeName = "ProductTypeName",
            Attribute = "Attribute",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            StoneColorId = "StoneColorId",
            ShapeId = "ShapeId",
            SieveId = "SieveId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            FromWt = "FromWt",
            ToWt = "ToWt",
            FromParts = "FromParts",
            ToParts = "ToParts",
            SettingId = "SettingId",
            ProcessId = "ProcessId",
            ProcessName = "ProcessName",
            CalcOnId = "CalcOnId",
            LossPer = "LossPer",
            PurStdLabour = "PurStdLabour",
            SaleStdLabour = "SaleStdLabour",
            MinLabour = "MinLabour",
            MaxLabour = "MaxLabour",
            MaxOrMin = "MaxOrMin",
            FixedName = "FixedName",
            RateType = "RateType",
            SuperTypeName = "SuperTypeName",
            BrandName = "BrandName",
            CollectionName = "CollectionName",
            ProcessTypeId = "ProcessTypeId",
            IsCustomerItem = "IsCustomerItem",
            CalculateTo = "CalculateTo",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
